import { TableCell, TableCellInner } from '../styles';

interface GroupingTableCellProps {
    children: React.ReactNode;
    fixedFirstColumn?: boolean;
    fixedLastColumn?: boolean;
    rowSelectionEnabled?: boolean;
    align?: 'start' | 'end';
    colSpan?: number;
}

export const GroupingTableCell = ({
    children,
    fixedFirstColumn = false,
    fixedLastColumn = false,
    rowSelectionEnabled = false,
    align = 'start',
    colSpan,
}: GroupingTableCellProps) => {
    return (
        <TableCell
            colSpan={colSpan}
            fixedFirstColumn={fixedFirstColumn}
            fixedLastColumn={fixedLastColumn}
            rowSelectionEnabled={rowSelectionEnabled}
        >
            <TableCellInner align={align}>{children}</TableCellInner>
        </TableCell>
    );
};
